export default __webpack_public_path__ + "static/media/1.828144b5.png";